import { createContext } from 'preact';
import { useEffect, useState } from 'preact/hooks';

export const FavoritesContext = createContext({});

export default function FavoritesProvider({ children }) {
	const [contextLoading, setContextLoading] = useState(true);
	const [favorites, setFavorites] = useState(null);
	const [favoriteToUpdate, setFavoriteToUpdate] = useState(null);

	async function getFavorites() {
		setContextLoading(true);
		const data = {
			action: 'get_favorites'
		};
		const res = await fetch(ajaxurl, {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Cache-Control': 'no-cache'
			},
			body: new URLSearchParams(data)
		});
		const parsed = await res.json();
		setFavorites(parsed.data);
		setContextLoading(false);
	}

	async function updateFavorites(favoriteToUpdate) {
		if (!favoriteToUpdate) {
			return;
		}
		const updateData = {
			action: 'update_favorites',
			id: favoriteToUpdate
		};
		const res = await fetch(ajaxurl, {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Cache-Control': 'no-cache'
			},
			body: new URLSearchParams(updateData)
		});
		const parsed = await res.json();
		setFavorites(parsed.data.favorites);
		setFavoriteToUpdate(null);
	}

	useEffect(() => {
		getFavorites();
	}, []);

	useEffect(() => {
		updateFavorites(favoriteToUpdate);
	}, [favoriteToUpdate]);

	const value = {
		favorites,
		setFavoriteToUpdate,
		contextLoading,
		setContextLoading
	};

	return (
		<FavoritesContext.Provider value={value}>
			{children}
		</FavoritesContext.Provider>
	);
}
